import script from "./AuctionDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AuctionDashboard.vue?vue&type=style&index=0&id=c595362c&lang=scss"

const __exports__ = script;

export default __exports__